import React, { type ReactElement } from 'react';

import { useTranslation } from '@framework/hooks';

import styles from './NativeAppsFooter.module.scss';

const NativeAppsFooter = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <footer className={styles.footer}>
            <span className={styles.name}>{t('Sherpany Support')}</span>
            <a href="tel:+41 44 515 89 60" className={styles.contact}>
                +41 44 515 89 60
            </a>
            <a href="mailto:support@sherpany.com" className={styles.contact}>
                support@sherpany.com
            </a>
        </footer>
    );
};

export default NativeAppsFooter;
